import React from 'react';
import styles from './StagesRowSelect.module.scss';
import Tab from '../../../../../../components/common/Tab/Tab';
import Tabs from '../../../../../../components/common/Tabs/Tabs';
import { useDispatch, useSelector } from 'react-redux';
import { setMonitoringStage } from '../../../../../../store/actions/housingStockActions';

const StagesRowSelect = ({ stages }) => {
  const dispatch = useDispatch();

  const monitoringStage = useSelector(
    (state) => state.housingStockStore.monitoringStage
  );

  const handleChange = (_evt, newValue) => {
    if (newValue !== monitoringStage) {
      dispatch(setMonitoringStage(newValue));
    }
  };

  return (
    <Tabs
      value={monitoringStage}
      onChange={handleChange}
      className={styles.tabs}
    >
      {stages.map((item, index) => (
        <Tab
          className={styles.tab}
          selectedClassName={styles.tabActive}
          key={item.id || index}
          label={item.value}
          value={item.id}
        />
      ))}
    </Tabs>
  );
};

export default StagesRowSelect;
